"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Users, Brain, Briefcase } from "lucide-react";
export default function WhoWeServeSnapshot() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const providers = [{
    icon: Users,
    label: "ABA Providers",
    description: "Comprehensive administrative support for Applied Behavior Analysis practices"
  }, {
    icon: Brain,
    label: "Behavioral Health",
    description: "Specialized billing and credentialing services for behavioral health professionals"
  }, {
    icon: Briefcase,
    label: "Private Practice",
    description: "Complete practice management solutions for independent healthcare providers"
  }];
  return <section id="who-we-serve-snapshot" className="relative overflow-hidden bg-dark-background text-foreground-dark py-24">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px]">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <circle cx="100" cy="100" r="80" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M100,40 L120,80 L100,70 L80,80 Z M100,160 L120,120 L100,130 L80,120 Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {}
        <h2 className="text-4xl md:text-5xl font-display font-semibold text-center mb-16 tracking-tight">
          Who We Serve
        </h2>

        {}
        <div ref={ref} className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16">
          {providers.map((provider, i) => {
          const Icon = provider.icon;
          return <Tooltip key={i}>
                <TooltipTrigger asChild>
                  <div data-index={i} className="group cursor-pointer" style={{
                animation: isVisible ? `slideInFromRight 600ms cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 150}ms forwards` : "none",
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateX(0)" : "translateX(100px)"
              }}>
                    <div className="flex flex-col items-center gap-4 transition-transform duration-300 ease-spring group-hover:scale-[1.02]">
                      <div className="w-24 h-24 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center transition-all duration-300 group-hover:bg-primary/30 group-hover:shadow-strong">
                        <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
                      </div>
                      <span className="text-lg font-medium text-center">{provider.label}</span>
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="max-w-xs">
                  <p className="text-sm">{provider.description}</p>
                </TooltipContent>
              </Tooltip>;
        })}
        </div>
      </div>

      <style>{`
        @keyframes slideInFromRight {
          from {
            opacity: 0;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </section>;
}